import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../features/language/useLanguage';
import type { WorkOrderSummary } from '../../../types/workOrder';
import { LotWorkOrderReadOnlyModal } from './LotWorkOrderReadOnlyModal';

interface LotRoastWorkOrderCellProps {
  lotId: string;
  workOrders: WorkOrderSummary[];
  readOnly: boolean;
  isLoading: boolean;
}

export const LotRoastWorkOrderCell: React.FC<LotRoastWorkOrderCellProps> = ({
  lotId,
  workOrders,
  readOnly,
  isLoading,
}) => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (isLoading) {
    return (
      <div className="flex justify-center">
        <div
          className="h-7 w-14 bg-gray-200 animate-pulse rounded-md"
          data-test-id={`lot-roast-wo-cell-skeleton-${lotId}`}
        />
      </div>
    );
  }

  if (workOrders.length === 0) {
    if (readOnly) {
      return (
        <div className="w-full text-center">
          <span className="text-gray-400 text-sm font-medium italic select-none">
            {t('common.table.na')}
          </span>
        </div>
      );
    }
    return (
      <div className="flex justify-center">
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            navigate('/work-orders?mode=roasting');
          }}
          className="px-3 py-1 rounded-md text-sm font-medium transition-colors whitespace-nowrap bg-gray-300 text-gray-700/50 hover:bg-gray-400"
          data-test-id={`lot-roast-wo-cell-add-${lotId}`}
        >
          {t('profileManager.actions.add')}
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="flex justify-center">
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setIsModalOpen(true);
          }}
          className="px-3 py-1 rounded-md text-sm font-medium transition-colors whitespace-nowrap bg-primary-500 text-white hover:bg-primary-700"
          data-test-id={`lot-roast-wo-cell-view-${lotId}`}
        >
          {t('reports.shift.view')}
        </button>
      </div>
      <div onClick={(e) => e.stopPropagation()}>
        <LotWorkOrderReadOnlyModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          workOrders={workOrders}
        />
      </div>
    </>
  );
};
